import React from 'react';
import UHCSidebarContractFooter from '../../../../Molecules/Server/Contract/Sidebar/Footer/Footer';
import UHCSidebarContractTop from '../../../../Molecules/Server/Contract/Sidebar/Top/Top';
import { UHCSidebarServerContractProps } from './Sidebar.interface';

export const UHCSidebarServerContract: React.FC<UHCSidebarServerContractProps> = (props: UHCSidebarServerContractProps) => {
    return(
        <>
            <UHCSidebarContractTop lines={props.linesSidebarTop} />
            <UHCSidebarContractFooter onClick={(e)=>{props.onClick(e)}} profileSelected={props.profileSelected} />
        </>
    )
}
